import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { GallerySlideshowProps } from 'types';

export const GallerySlideshow: React.FC<GallerySlideshowProps> = ({
  images,
}) => {
  return <ImageGallery items={images} />;
};
